/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRulerMeasure2 = createReactComponent("outline", "ruler-measure-2", "IconRulerMeasure2", [["path", { "d": "M12 19.875c0 .621 -.512 1.125 -1.143 1.125h-5.714a1.134 1.134 0 0 1 -1.143 -1.125v-15.875a1 1 0 0 1 1 -1h5.857c.631 0 1.143 .504 1.143 1.125z", "key": "svg-0" }], ["path", { "d": "M12 9h-2", "key": "svg-1" }], ["path", { "d": "M12 6h-3", "key": "svg-2" }], ["path", { "d": "M12 12h-3", "key": "svg-3" }], ["path", { "d": "M12 18h-3", "key": "svg-4" }], ["path", { "d": "M12 15h-2", "key": "svg-5" }], ["path", { "d": "M21 3h-4", "key": "svg-6" }], ["path", { "d": "M19 3v18", "key": "svg-7" }], ["path", { "d": "M21 21h-4", "key": "svg-8" }]]);

export { IconRulerMeasure2 as default };
//# sourceMappingURL=IconRulerMeasure2.mjs.map
